/** A tölcsér lépéseinek számítása (az Elemzés oldal fő ábrájához). */
export interface TolcserBemenet { lepes: string; db: number }
export type TolcserLepes<T extends TolcserBemenet = TolcserBemenet> = T & {
  /** Az első lépéshez viszonyított arány, 0–1 (nulla nevezőnél 0). */
  arany: number;
  /** Az előző lépésből átjutók aránya; az első lépésnél és nulla nevezőnél null. */
  atvaltas: number | null;
};

/** A bemenet további mezőit (pl. `cimke`) megőrzi. */
export function tolcserLepesek<T extends TolcserBemenet>(lepesek: readonly T[]): TolcserLepes<T>[] {
  const elso = lepesek[0]?.db ?? 0;
  return lepesek.map((l, i) => {
    const elozo = i > 0 ? lepesek[i - 1]!.db : 0;
    return {
      ...l,
      arany: elso > 0 ? l.db / elso : 0,
      atvaltas: i > 0 && elozo > 0 ? l.db / elozo : null,
    };
  });
}

export function szazalekSzoveg(arany: number | null): string {
  return arany === null ? '–' : `${Math.round(arany * 100)}%`;
}

/** A lépés neve alatti halk sor; az első lépésnél (nincs előző) null. */
export function atvaltasFelirat(atvaltas: number | null): string | null {
  return atvaltas === null ? null : `${szazalekSzoveg(atvaltas)} az előzőből`;
}
